const cricketData = [
    //Workspace: Cricket Usage Insights
    {
        "category": "app",
        "type": 'internal',
        "name": "Cricket Usage Insights",
        "keyUsers": "R&D, Business Development",
        "access": "Limited",
        "keyUseCases": "<ul><li>Insights into the usage of the cricket product</li></ul>",
        "dataSummary": "<ul><li>History: All available cricket data</li><li>Updates Daily: Automatic</li></ul>",
        "reports": [
            {
                reportId: '3e889c84-006e-4d7b-9e17-a8e1e894082e',
                applicationId: '0e081d15-6694-45f2-a50f-e68466d5c9da',
                name: "Cricket Usage Insights",
                visible: false
            }
        ]
    }
]


// ****************** UPDATE ALL THE OBJECTS WITH APP URL AND SPORT ****************** //
function createUrlFromName(name) {
    let url = name.toLowerCase();
    url = url.replace(/[^\w\s-]/g, '-');
    url = url.replace(/[\s-]+/g, '-');
    return url;
}

function updateAppIds(objects) {
    objects.forEach(obj => {
        const urlFromName = createUrlFromName(obj.name);
        const sport = 'cricket';
        obj.appId = urlFromName;
        obj.sport = sport;
        obj.reports = obj.reports.map(item => ({...item, appId: urlFromName, sport: sport}));
    });
}

updateAppIds(cricketData);
export {cricketData};